import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Alert,
  CircularProgress,
} from "@mui/material";
import api from "../../services/api/axios";
import { BRAND_BLUE } from "../../theme/colors";

function formatDateTime(val) {
  if (!val) return "—";
  const d = new Date(val);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString();
}

export default function AdminDemoVideoLeads() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get("/admin/demo-leads");
        setRows(res.data || []);
      } catch (e) {
        setError(e?.response?.data?.detail || "Failed to load demo video leads");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ color: BRAND_BLUE }}>
        Demo Video Leads
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Visitors who filled out the landing page form to unlock the demo video.
      </Typography>

      {error && <Alert severity="error">{error}</Alert>}

      <Paper sx={{ mt: 1, border: `2px solid ${BRAND_BLUE}`, borderRadius: 4 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ color: BRAND_BLUE }}>Name</TableCell>
              <TableCell sx={{ color: BRAND_BLUE }}>Organization</TableCell>
              <TableCell sx={{ color: BRAND_BLUE }}>Work Phone</TableCell>
              <TableCell sx={{ color: BRAND_BLUE }}>Email</TableCell>
              <TableCell sx={{ color: BRAND_BLUE }}>Submitted</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.id}>
                <TableCell sx={{ color: BRAND_BLUE }}>{r.name}</TableCell>
                <TableCell sx={{ color: BRAND_BLUE }}>{r.organization}</TableCell>
                <TableCell sx={{ color: BRAND_BLUE }}>{r.work_phone}</TableCell>
                <TableCell sx={{ color: BRAND_BLUE }}>{r.email}</TableCell>
                <TableCell sx={{ color: BRAND_BLUE }}>
                  {formatDateTime(r.created_at)}
                </TableCell>
              </TableRow>
            ))}

            {loading && (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <CircularProgress size={20} />
                </TableCell>
              </TableRow>
            )}

            {!loading && rows.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No demo video leads yet
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}
